module.exports = __webpack_public_path__ + "static/media/first-example.1e5dc0e4.png";